module.exports = __webpack_public_path__ + "static/media/D3_C2_001.21ac7875.png";